import { Card, SkeletonDisplayText, Layout } from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';

const ProjectDetailLoading = () => {
  return (
    <div>
      <Layout>
        <Layout.Section>
          <div className="no-shadow-card">
            <Card sectioned>
              <div className="mt10">
                <Layout>
                  <Layout.Section oneHalf>
                    <SkeletonDisplayText size="medium" />
                  </Layout.Section>
                  <Layout.Section oneHalf>
                    <SkeletonDisplayText size="medium" />
                  </Layout.Section>
                </Layout>
                <div className="mt10">
                  <Layout>
                    <Layout.Section oneHalf>
                      <SkeletonDisplayText size="medium" />
                    </Layout.Section>
                    <Layout.Section oneHalf>
                      <SkeletonDisplayText size="medium" />
                    </Layout.Section>
                  </Layout>
                </div>
                <div className="mt10">
                  <Layout>
                    <Layout.Section oneHalf>
                      <SkeletonDisplayText size="medium" />
                    </Layout.Section>
                    <Layout.Section oneHalf>
                      <SkeletonDisplayText size="medium" />
                    </Layout.Section>
                  </Layout>
                </div>
              </div>
            </Card>
          </div>
        </Layout.Section>
      </Layout>
    </div>
  );
};

export default ProjectDetailLoading;
